<template>
    <div class="topbar">
        <img src="../assets/icon/LOGO-Chanel-white.svg" >
        <!-- <img src="../assets/icon/white@3x.png" /> -->
        <!-- <img src="@/assets/img/logochanel.png" class="img-logo"/> -->
    </div>
</template>
<script>
export default {
    name: 'top-bar',// <top-bar>
}
</script>
<style lang="scss" scoped>

    .topbar {

        padding: 15px 120px;
        border-top: 4px solid #000000;
        padding-top: 40px;
        text-align: center;

        img {
            width: 100%;
            max-width: 200px;
            height: auto;
        }
    }

</style>
